/**
 * Format a date string or Date object to yyyy-MM-dd format.
 * Returns '—' for falsy values.
 */
export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '—';
  const d = new Date(date);

  if (isNaN(d.getTime())) return '—';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

/**
 * Format a date string or Date object to yyyy-MM-dd HH:mm:ss format.
 * Returns '—' for falsy values.
 */
export const formatDateTime = (
  date: string | Date | null | undefined,
): string => {
  if (!date) return '—';
  const d = new Date(date);

  if (isNaN(d.getTime())) return '—';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
